import React from 'react';
import CompatioApi from '../../api/CompatioApiXrsV3';
import EcommerceApi from '../../api/EcommerceApi';
import ReactResizeDetector from 'react-resize-detector';
import { FormattedMessage } from 'react-intl';
import _, { get as _get } from 'lodash-es';
import ProductList from '../product-list/ProductListXrs';
import CompatibleProduct from './CompatibleProduct';
import CompatioAnalytics from '../../api/CompatioAnalytics';
import PopupXRS from '../popups/PopupXRS';
import ProductSort from '../utils/ProductSort';
import compatioImg from '../../styles/images/build-it-out.png';
import PopupBundler from '../popups/PopupBundlerCollection';

class CompatibleProducts extends React.Component {
  /**
   * Track whether component is mounted
   *
   * @type {boolean}
   * @private
   */
  _isMounted = false;

  anchor = document.getElementById('xrsanchor');

  static defaultProps = {
    /**
     * The merchant product ID. This value should always be passed in during the initialization of this component
     */
    productSku: null,
    /**
     * The product name of the current product being viewed.
     */
    productName: null,
    /**
     * Products to show user until "Show More" button hides the rest of the products
     */
    productsPerPage: 10,
    /**
     * Breakpoint to switch between tabs/accordion behavior
     */
    desktopModeWidth: 768,
    /**
     * For variable products, if user hasn't selected a specific product, a random child SKU will be passed to this
     * component so that a list of categories can be retrieved from the Compatio API. If a random SKU is passed, this
     * prop should be set to "true"
     */
    isProductSkuRandom: false,
    /**
     * If enabled, when page first loads, all product data will be retrieved from ecommerce API (for the
     * first "productsPerPage" products within each category). This will result in compatible products showing
     * immediately when a category is clicked. However it will result in more bandwidth usage for users and a
     * higher load on the ecommerce server API.
     */
    isPreloadEcommerceDataEnabled: true,
  };

  constructor(props) {
    super(props);
    const merchantProductSku = props.productSku;
    const merchantProductName = props.productName;
    if (
      _get(
        window,
        'compatioConfig.compatibleProducts.callbacks.beforeConstruct'
      )
    ) {
      window.compatioConfig.compatibleProducts.callbacks.beforeConstruct();
    }

    window.compatioConfig.compatibleProducts.methods =
      window.compatioConfig.compatibleProducts.methods || {};

    // Register function in global namespace
    window.compatioConfig.compatibleProducts.methods.handleChangeProductSku = this.handleChangeProductSku.bind(
      this
    );

    window.compatioConfig.compatibleProducts.methods.handleProductDataUpdate = this.handleProductDataUpdate.bind(
      this
    );

    window.compatioConfig.compatibleProducts.methods.handleProductDataUpdateVariantLevel = this.handleProductDataUpdateVariantLevel.bind(
      this
    );
    this.state = {
      customProName: '',
      customProImg: '',
      customProPrice: '',
      compatioCategories: [],
      activeCompatioCategories: {},
      defaultSorting: 'compatioscore_descending',
      merchantProductSku: merchantProductSku,
      merchantProductName: merchantProductName,
      isProductSkuRandom: this.props.isProductSkuRandom,
      isBundlerOpen: false,
      IsPlatformShopify:
        typeof _get(window, 'compatioConfig.shopify') === 'object',
      errorMessage: false,
      maximumProducts: _get(window, 'compatioConfig.shopify.maximumProducts')
        ? _get(window, 'compatioConfig.shopify.maximumProducts')
        : _get(window, 'compatioConfig.magento.maximumProducts'),
      maximumCategories: _get(
        window,
        'compatioConfig.shopify.maximumCategories'
      )
        ? _get(window, 'compatioConfig.shopify.maximumCategories')
        : _get(window, 'compatioConfig.magento.maximumCategories'),
    };

    this.setMerchantProductSku(merchantProductSku);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggleBundler = () => {
    const { isBundlerOpen } = this.state;
    this.setState({
      isBundlerOpen: !isBundlerOpen,
    });
  };

  /**
   * Update sort order
   *
   * @param sortOrder
   */

  /**
   * Allow a third-party script to update the current merchant product ID
   *
   * Ecommerce platform will call this when a user changes the child SKU on a Variable Product page
   *
   * @param productSku
   * @param isProductSkuRandom
   */
  handleChangeProductSku(productSku, isProductSkuRandom) {
    // If isProductSkuRandom is undefined, coerce to false
    isProductSkuRandom = !!isProductSkuRandom;

    // Don't update anything if nothing has changed
    if (
      productSku === this.state.merchantProductSku &&
      isProductSkuRandom === this.state.isProductSkuRandom
    ) {
      // return;
    }
    this.setState({ isProductSkuRandom: isProductSkuRandom });
    this.setMerchantProductSku(productSku);
  }

  /**
   * Update this component to show compatibility information for a different product ID
   *
   * @param merchantProductSku
   * @returns {Promise<void>}
   */
  async setMerchantProductSku(merchantProductSku) {
    if (merchantProductSku && merchantProductSku != '') {
      try {
        const compatioCategoryData = await CompatioApi.getCategoryDataByProductSku(
          merchantProductSku,
          this.state.maximumCategories,
          this.state.maximumProducts
        );
        // console.log(compatioCategoryData, 'compatioCategoryData');

        if (compatioCategoryData.length > 0) {
          if (this.anchor != null) {
            this.anchor.style.display = 'block';
          }
          if (this._isMounted) {
            this.setState({
              merchantProductSku: merchantProductSku,
              compatioCategories: compatioCategoryData,
              errorMessage: false,
            });
          }
          const eCommercePlatform = this.state.IsPlatformShopify
            ? 'shopify'
            : '';

          if (!this.props.isPreloadEcommerceDataEnabled) {
            return;
          }

          const allMerchantProductSkus = CompatioApi.extractAllProductSkus(
            compatioCategoryData
          );
          try {
            // Preload ecommerce data; don't do anything with the returned data
            await EcommerceApi.loadProductDataFromEcommerceXrs(
              allMerchantProductSkus,
              eCommercePlatform,
              compatioCategoryData
            );
            // console.log(allMerchantProductSkus,'allMerchantProductSkus')
          } catch (e) {
            // Don't do anything with errors thrown by loadProductDataFromEcommerce (such as an API timeout), since
            // subsequent calls to this method could be successful (since it will be a smaller set of data requested)
            console.error(e);
          }
        } else {
          this.anchor.style.display = 'none';
          this.setState({
            errorMessage: true,
          });
        }
      } catch (e) {
        this.setState({
          errorMessage: true,
        });
        //console.error(e);
      }
    }
  }

  handleProductDataUpdate(productState) {
    // console.log(productState.variants,'productState.variants')
    if(productState.variants !=undefined){
      // console.log(productState,'productState', productState.variants.filter(e => e.available !== false)[0].name);
      this.setState({
        // customProName: productState.variants[0].name,
        customProName: productState.variants.filter(e => e.available !== false)[0].name,
        customProImg: productState.url_image,
        customProPrice: productState.priceNew ,
      });
    }else{      
      if (productState != undefined) {
        this.setState({
          // customProName: productState.variants[0].name,
          customProName: productState.name,
          customProImg: productState.featured_image,
          customProPrice: productState.priceNew ,
        });
      }
    }
  }

  handleProductDataUpdateVariantLevel(productState) { 
    if (productState.length != 0 && productState.length != undefined) {
      // console.log(productState[0].name, 'productState');
      this.setState({
        customProName: productState[0].name,
      });
    }

    // customProName :'',
    // customProImg :'',
    // customProPrice:'',
    // console.log(productState,this.props,this.state.customProName)
  }
  /**
   * Toggle mode, if resize has resulted in mode changing
   */

  render() {
    const compatioCategories = _.cloneDeep(this.state.compatioCategories);
    if (this.state.errorMessage !== false) return null;
    if (!compatioCategories.length) {
      //CompatioApi.reset();
      return null;
    }

    return (
      <>
        <button
          id="xrs-bundle"
          className="button"
          onClick={this.toggleBundler}
          style={{ visibility: 'hidden' }}
        >
          Open Bundler
        </button>
        {this.state.isBundlerOpen ? (
          <PopupBundler
            isOpen={this.state.isBundlerOpen}
            bundlerType="bundler"
            toggleBundler={this.toggleBundler}
            productData={[...compatioCategories]}
            parentProduct={this.props}
            parentProductSku={this.state.merchantProductSku}
            customProName={this.state.customProName}
            customProImg={this.state.customProImg}
            customProPrice={this.state.customProPrice}
            defaultBacking={
              this.props.backingData &&
              this.props.backingData[0] &&
              this.props.backingData[0].variantId
            }
          />
        ) : null}
      </>
    );
  }
}

export default CompatibleProducts;
